import React from 'react'
import Header from '../../Header/Header'
import 'bootstrap/dist/css/bootstrap.min.css';
import '../innerpage.css'
import { Row, Container, Col } from 'react-bootstrap'

import applyvisa from '../../../images/applyvisa.png'

const VisaBanner = () => {
    return (
        <>
            <div className='innerbanner pt-4'>
                <Header></Header>
                <div className='container-fluid'>
                    <Container>
                        <Row className='d-flex justify-content-center align-items-center'>
                            <Col md={5}>
                                <img src={applyvisa} alt="applyvisa" className='animated2 infinite fadeInLeftRight'></img>
                            </Col>
                            <Col md={7}>
                                <h2>Apply for <span>Visa</span></h2>
                                <p>Fly towards your Dream.  </p>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </>
    )
}

export default VisaBanner